import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { InforIndicadoresDtoI } from 'src/app/modelos/InformacionIndicadoresDto';
import { PeriodoReporteI } from 'src/app/modelos/PeriodoReporte';
import { ApiService } from 'src/app/servicios/api/api.service';
import { AppServiceService } from 'src/app/servicios/AppService.service';
import html2canvas from 'html2canvas';
import autoTable from 'jspdf-autotable';
import fromHTML from 'jspdf';
import { Canvas } from 'pdfmake-wrapper';
import { read, writeFileXLSX } from "xlsx";
import { FuentesPuntajesDtoI } from 'src/app/modelos/FuentesPuntajesDto';
import { IndicadoresService } from 'src/app/servicios/indicadores/indicadores.service';
import jsPDF from 'jspdf';
import 'jspdf-autotable';


declare var Plotly: any;

@Component({
  selector: 'app-indicadoreschv',
  templateUrl: './indicadoreschv.component.html',
  styleUrls: ['./indicadoreschv.component.css']
})
export class IndicadoreschvComponent implements OnInit {

  PeriodoSeleccionado : PeriodoReporteI = new PeriodoReporteI;
  ListaPeriodosConsultar : PeriodoReporteI[];
  InformacionIndicadores : InforIndicadoresDtoI = new InforIndicadoresDtoI;
  TablaIndicadores : FuentesPuntajesDtoI[];
  stringBase64 : any = "";
  stringPdfBase64 : any = "";

  @ViewChild('openmodalcargando') openmodalcargando: ElementRef;
  @ViewChild('closemodacargando') closemodacargando: ElementRef;

  constructor(
    private api:ApiService,
    private router:Router,
    private toastr: ToastrService,
    private appService:AppServiceService,
    private indicadoresService:IndicadoresService
  ) { }

  ngOnInit(): void {
    this.api.consultarPeriodoActivoCHV().subscribe(Result=>{
      this.PeriodoSeleccionado = Result;
      this.actualizarGraficas(Result.id);
    });
    this.api.listaPeriodosCalendario().subscribe(Result2=>{
      this.ListaPeriodosConsultar = Result2;
    });
  }

  RegresarOperativo(){
    this.router.navigate(['indicadores']);
  }

  actualizarGraficas(IdPeriodo){
    this.api.PeriodoPorId(IdPeriodo).subscribe(Result5=>{
      this.PeriodoSeleccionado = Result5;
      this.indicadoresService.InformacionIndicadoresChv(Result5.id).subscribe(Result6=>{
        if(Result6){
          this.InformacionIndicadores = Result6;
          this.stringBase64 = Result6.doc;
          this.stringPdfBase64 = Result6.pdf;
          this.TablaIndicadores = Result6.fuentesPunajes;
          var layout = {
            height: 400,
            width: 500,
            showlegend: false
          };
          var layout1 = {
            height: 400,
            width: 500,
            showlegend: false
          };
          var options: any = {
            displayModeBar: false,
            staticPlot: true,
            responsive: true
          };
          var data1 = [{
            values: [(Result6.numeroTotalFtes-Result6.numeroFtesReportaron), Result6.numeroFtesReportaron],
            labels: ['Número fuentes no reportan', 'Número fuentes reportan'],
            type: 'pie',
            marker: {colors: ['rgb(205,0,75)','rgb(18,30,153)']},
            textinfo: "label+percent",
            textposition: "outside",
            automargin: true
          }];
          Plotly.newPlot('myPlotlyDiv1', data1, layout, options);
          //Plotly.newPlot('myPlotlyDiv1_2', data1, layout, options);
          var data2 = [{
            values: [(100 - Result6.icif), Result6.icif],
            labels: [' ', 'ICIf'],
            type: 'pie',
            marker: {colors: ['rgb(205,0,75)','rgb(18,30,153)']},
            textinfo: "label+percent",
            textposition: "outside",
            automargin: true
          }];
          Plotly.newPlot('myPlotlyDiv2', data2, layout1,options);
          //Plotly.newPlot('myPlotlyDiv2_2', data2, layout1,options);
          var data3 = [{
            values: [(100 - Result6.icri), Result6.icri],
            labels: [' ', 'ICRI'],
            type: 'pie',
            marker: {colors: ['rgb(205,0,75)','rgb(18,30,153)']},
            textinfo: "label+percent",
            textposition: "outside",
            automargin: true
          }];
          Plotly.newPlot('myPlotlyDiv3', data3, layout1,options);
          //Plotly.newPlot('myPlotlyDiv3_2', data3, layout1,options);
          var data4 = [{
            values: [(100 - Result6.icg), Result6.icg],
            labels: [' ', 'ICG'],
            type: 'pie',
            marker: {colors: ['rgb(205,0,75)','rgb(18,30,153)']},
            textinfo: "label+percent",
            textposition: "outside",
            automargin: true
          }];
          Plotly.newPlot('myPlotlyDiv4', data4, layout1,options);
          //Plotly.newPlot('myPlotlyDiv4_2', data4, layout1,options);
        }
      });
    });
  }

  descargarArchivoExcel() {
    if (this.stringBase64) {
      const blob = this.base64toBlob(this.stringBase64, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = url;
      a.download = 'Indicadores periodo '+this.PeriodoSeleccionado.consecutivoPeriodo+' '+this.PeriodoSeleccionado.anio+'.xlsx';
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    } else {
      console.error('No hay datos para descargar');
    }
  }

  descargarArchivoPDF() {
    if (this.stringPdfBase64) {
      const blob = this.base64toBlob(this.stringPdfBase64, 'application/pdf');
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = url;
      a.download = 'Indicadores periodo ' +this.PeriodoSeleccionado.consecutivoPeriodo+' '+this.PeriodoSeleccionado.anio+ '.pdf';
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    } else {
      console.error('No hay datos para descargar');
    }
  }

  base64toBlob(base64Data: string, contentType: string): Blob {
    const sliceSize = 512;
    const byteCharacters = atob(base64Data);
    const byteArrays: Uint8Array[] = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    return new Blob(byteArrays, { type: contentType });
  }
}
